export const SET_CURRENT_ACTIVE_MENU = 'SET_CURRENT_ACTIVE_MENU'

export const SET_USER_INFO = 'SET_USER_INFO'

export const SAVE_ACTIVITY_SUCCESS = 'SAVE_ACTIVITY_SUCCESS'